export function resolveNestedKey(obj, key) {
	return key
		.split(".")
		.reduce((acc, part) => (acc && acc[part] ? acc[part] : undefined), obj);
}

export function formatDate(dateString) {
	if (!dateString) return "";

	const date = new Date(dateString);
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();

	return `${day}-${month}-${year}`;
}

export function maskNumber(character) {
	if (!character) return "";
	return character.slice(0, 3) + "*****" + character.slice(8);
}

export function formatTier(accountType, tier) {
	if (tier) {
		return accountType === "business-account"
			? tier.slice(-1).toUpperCase()
			: tier.slice(-1);
	}
	return "-";
}

export function capitalize(str) {
	if (!str) return "";
	if (typeof str !== "string") return str;

	return str
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}

export function validateBvnInput(bvn) {
	const bvnRegex = /^\d{0,11}$/;
	if (!bvnRegex.test(bvn)) {
		const sanitizedBvn = bvn.replace(/\D/g, "");
		return {
			isValid: false,
			errorMessage: "BVN must contain only numeric characters.",
			sanitizedValue: sanitizedBvn,
		};
	} else if (bvn.length === 11) {
		return { isValid: true, errorMessage: "", sanitizedValue: bvn };
	}
	return { isValid: true, errorMessage: "", sanitizedValue: bvn };
}

export function validateDateOfBirth(dateOfBirth) {
	const dobRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(19|20)\d{2}$/;
	if (dateOfBirth && !dobRegex.test(dateOfBirth)) {
		return {
			isValid: false,
			errorMessage: "Date of Birth must be in the format DD-MM-YYYY.",
		};
	}
	return { isValid: true, errorMessage: "" };
}

export function isValidDateOfBirth(dob) {
	const dobRegex = /^\d{2}-\d{2}-\d{4}$/;
	if (!dobRegex.test(dob)) return false;

	const [day, month, year] = dob.split("-").map(Number);

	if (isNaN(day) || isNaN(month) || isNaN(year)) return false;

	if (
		day < 1 ||
		day > 31 ||
		month < 1 ||
		month > 12 ||
		year < 1900 ||
		year > new Date().getFullYear()
	) {
		return false;
	}

	const date = new Date(year, month - 1, day);
	return (
		date.getDate() === day &&
		date.getMonth() === month - 1 &&
		date.getFullYear() === year
	);
}

export function handleDateOfBirthInput(value) {
	let input = value.replace(/\D/g, "").slice(0, 8);
	input = input
		.replace(/^(\d{2})(\d{0,2})/, "$1-$2")
		.replace(/^(\d{2}-\d{2})(\d{0,4})/, "$1-$2");

	const validationError =
		input.length === 10 && !isValidDateOfBirth(input)
			? "Please enter a valid date in DD-MM-YYYY format."
			: "";

	return { formattedValue: input, validationError };
}

export const isDigitValid = (digit) => {
	return /^\d{11}$/.test(digit);
};

export const validateDigit = (field, validation) => {
	const digit = field.value;
	if (digit.length !== 11) {
		validation.errors[field.key] = "Phone number must be exactly 11 digits.";
	} else {
		validation.errors[field.key] = "";
	}
};

export const validateTinInput = (event, updateTin) => {
	const sanitizedValue = event.target.value.replace(/[^0-9-.]/g, "");
	updateTin(sanitizedValue);
};

export const handleInput = (field, validationErrors) => {
	switch (field.key) {
		case "phoneNumber":
		case "businessPhoneNumber":
		case "nin":
			field.value = field.value.replace(/\D/g, "").slice(0, 11);
			if (!/^\d{11}$/.test(field.value)) {
				validationErrors[field.key] = "Phone number must be 11 digits.";
			} else {
				validationErrors[field.key] = "";
			}
			break;

		case "nationality":
			field.value = field.value.replace(/[^a-zA-Z\s]/g, "");
			break;

		case "dateOfBirth":
			const { formattedValue, validationError } = handleDateOfBirthInput(
				field.value
			);
			field.value = formattedValue;
			if (validationError) validationErrors[field.key] = validationError;
			else validationErrors[field.key] = "";
			break;

		default:
			break;
	}
};

export const validateField = (field) => {
	const errors = {};
	switch (field.key) {
		case "phoneNumber":
		case "businessPhoneNumber":
			if (!/^\d{11}$/.test(field.value)) {
				errors[field.key] = "Phone number must be exactly 11 digits.";
			}
			break;

		case "dateOfBirth":
			const isValidDOB = isValidDateOfBirth(field.value);
			if (!isValidDOB) {
				errors[field.key] = "Invalid date format. Use DD-MM-YYYY.";
			}
			break;

		case "tin":
			if (!/^[0-9-.]+$/.test(field.value)) {
				errors[field.key] = "TIN must contain only numbers, dashes, or dots.";
			}
			break;

		default:
			break;
	}
	return errors;
};

export const formatDocumentName = (name) => {
	return name ? name.replace(/-/g, " ").toUpperCase() : "";
};
